export default __webpack_public_path__ + "static/media/scene_12.229e86e5.mp3";